(ns common.schema.entities.survey.mandatoriness-style
  (:require [common.localization :as loc]))

(def default :mandatoriness-style/default)
(def red-asterisk :mandatoriness-style/red-asterisk)
(def highlight-when-validate-fails :mandatoriness-style/highlight-when-mandatoriness-fails)

(defn options
  [lang]
  (->> [default red-asterisk highlight-when-validate-fails]
       (map (fn [k]
              {:value k
               :label (loc/tr k nil lang)}))
       (sort-by :label)))
